import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@workspace/web-ui/components/select"
import { filters } from "../../libs/filters"

interface FiltersProps {
    filter: string
    setFilter: React.Dispatch<React.SetStateAction<string>>
}

export const Filters = ({ filter, setFilter }: FiltersProps)=> {
    const handleFilterChange = (value: string) => {
        setFilter(value)
    }

    return (
        <Select value={filter} onValueChange={handleFilterChange}>
            <SelectTrigger className="w-fit button-primary !px-3 !py-3">
                <SelectValue placeholder="Sort" />
            </SelectTrigger>
            <SelectContent>
                {filters.map((filterItem) => (
                    <SelectItem 
                        key={filterItem.value} 
                        value={filterItem.value}
                    >
                        {filterItem.label}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>   
    )
}